(function () {
  const baseScrollbarSettings = {
    loop: true,
    slidesPerView: 1.3,
    spaceBetween: 16,
    speed: 400,
    allowTouchMove: true,
    mousewheel: { forceToAxis: true },
    watchSlidesProgress: true,
    on: {
      init: function() {
        this.slides.forEach((slide, index) => {
          const img = slide.querySelector('.collection_list_item img');
          img.classList.add(index % 2 === 0 ? 'odd' : 'even');
        });
      }
    },
    breakpoints: {
      750: {     
        centeredSlides: true,
        centeredSlidesBounds: true,
        slidesPerView: 4,
        slidesOffsetBefore: 0
      },
      1440: { 
        slidesPerView: 4,
        slidesOffsetBefore: 0,
        centeredSlides: true,
        centeredSlidesBounds: true,
       },
    },
  };

  const baseSliderSettings = {
    slidesPerView: 1.3,
    spaceBetween: 16,
    speed: 500,
    loop: true,
    allowTouchMove: true,
    on: {
      init: function() {
        this.slides.forEach((slide, index) => {
          const img = slide.querySelector('.collection_list_item img');
          img.classList.add(index % 2 === 0 ? 'odd' : 'even');
        });
      }
    },
    breakpoints: {
      750: {     
        centeredSlides: true,
        centeredSlidesBounds: true,
        slidesPerView: 4,
        slidesOffsetBefore: 0
      },
      1440: { 
        slidesPerView: 4,
        slidesOffsetBefore: 0,
        centeredSlides: true,
        centeredSlidesBounds: true,
       },
    },
  };

  const initSliders = (section, layout) => {
    const swiperEls = section.querySelectorAll(".products-tabs__wrapper-y-story");
    
    swiperEls.forEach((swiperEl) => {
      const swiperWrapper = swiperEl.querySelector(".products-tabs__inner");
      const slides = swiperEl.querySelectorAll(".products-tabs__list");
      if (!swiperWrapper || !slides.length) return;

      const mobSlidesPerView = section.classList.contains("products-tabs--visible-overflow")
        ? 1.3
        : 1.3;


        swiperEl.classList.add("swiper");
        swiperWrapper.classList.add("swiper-wrapper");
        
        slides.forEach((slide, index) => {
          slide.classList.add("swiper-slide");
          let coeff = slides.length > 24 ? 0.02 : slides.length > 12 ? 0.05 : 0.1;
          slide.style.setProperty("--prod-tabs-item-delay", `${index * coeff}s`);
        });

      const progressBar = section.querySelector(".products-tabs__bar");
      const nextBtn = section.querySelector(".products-tabs__navigation-button-next");
      const prevBtn = section.querySelector(".products-tabs__navigation-button-prev");

      let finalSettings = layout === "bar"
        ? {
            ...baseScrollbarSettings,
            scrollbar: {
              el: progressBar,
              draggable: true,
              hide: false,
            },
          }
        : {
            ...baseSliderSettings,
            slidesPerView: mobSlidesPerView,
          };

      if (nextBtn && prevBtn) {
        finalSettings.navigation = {
          nextEl: nextBtn,
          prevEl: prevBtn,
          disabledClass: "swiper-button-disabled",
        };
      }

      // Inisialisasi Swiper
      new Swiper(swiperEl, finalSettings);
    });
  };

  const destroySliders = (section) => {
    const swiperEls = section.querySelectorAll(".products-tabs__wrapper-y-story");
    swiperEls.forEach((swiperEl) => {
      const swiperInstance = swiperEl.swiper;
      const swiperWrapper = swiperEl.querySelector(".products-tabs__inner");
      const slides = swiperEl.querySelectorAll(".products-tabs__list");

      if (swiperInstance) {
        swiperInstance.destroy();
      }
      
      swiperEl.classList.remove("swiper");
      if (swiperWrapper) swiperWrapper.classList.remove("swiper-wrapper");
      if (slides.length) {
        slides.forEach((slide) => slide.classList.remove("swiper-slide"));
      }
    });
  };

  // Fungsi lainnya tetap sama...
  const toggleTab = (section) => {
    // Implementasi toggleTab...
  };

  const initProductsTabs = (section) => {
    if (!section?.classList.contains("products-tabs")) return;

    const sliderContainer = section;
    const layout = sliderContainer.dataset.layout || "grid";
    const mobileLayout = sliderContainer.dataset.layoutMobile || "column";
    let currentLayout = null;

    const observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const width = entry.contentRect.width;
        const isMobile = width < 576;

        const newLayout = isMobile
          ? mobileLayout === "slider" ? "slider" : "column"
          : layout === "bar" ? "bar" : "grid";

        if (newLayout !== currentLayout) {
          currentLayout = newLayout;
          destroySliders(section);
          if (newLayout === "slider" || newLayout === "bar") {
            initSliders(section, newLayout);
          }
        }
      });
    });

    observer.observe(section);
    toggleTab(section);
  };

  const animateProductCards = (section) => {
    if (!section?.classList.contains("products-tabs")) return;

    const wrapper = section.querySelector(".products-tabs__inner");
    if (!wrapper || !wrapper.classList.contains("animate-on-scroll")) return;

    ScrollTrigger.create({
      trigger: wrapper,
      start: "20% bottom",
      end: "bottom top",
      onEnter: () => wrapper.classList.add("animated"),
    });
  };

  // Inisialisasi
  document.addEventListener("DOMContentLoaded", () => {
    const sections = document.querySelectorAll(".products-tabs");
    sections.forEach((section) => {
      initProductsTabs(section);
      animateProductCards(section);
    });
  });

  document.addEventListener("shopify:section:load", (event) => {
    const section = event.target.querySelector(".products-tabs") || event.target;
    if (section.classList.contains("products-tabs")) {
      initProductsTabs(section);
      animateProductCards(section);
    }
  });
})();